/* RESPONSIBLE TEAM: team-workflows */
import type AnswerTerminal from 'embercom/models/operator/visual-builder/step/answer-terminal';
import StepConfig, { type StepConfigParams } from '../step';

export default class AnswerTerminalConfiguration extends StepConfig {
  declare step: AnswerTerminal;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/answer-terminal',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
